module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content",
    on: {
      "click": _vm.onDatepickerClose
    }
  }, [(_vm.showSubscriptionPlan) ? _c('div', {
    staticClass: "form-row flex-nowrap flex--align-vertical"
  }, [_c('div', {
    staticClass: "flex-grow-1 pr10"
  }, [_c('label', {
    attrs: {
      "for": "dropbox-link"
    }
  }, [_vm._v("Subscription plan")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planList.selected),
      expression: "planList.selected"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disabledChangePlan
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.planList, "selected", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.planList.options), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "flex-none pl10"
  }, [_c('label', {
    attrs: {
      "for": "dropbox-link"
    }
  }, [_vm._v("select date")]), _vm._v(" "), _c('datepicker', {
    ref: "projectSettingsDatepicker",
    staticClass: "datepicker--settings h-100",
    attrs: {
      "taskDeadline": _vm.projectDeadline,
      "useInSeconds": true
    },
    on: {
      "updateDeadline": _vm.onUpdateDeadline
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showSubscriptionPlan) ? _c('button', {
    staticClass: "btn w-100 mb20",
    attrs: {
      "disabled": _vm.disabledUpdatePlan
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatePlan()
      }
    }
  }, [_vm._v("Change Plan")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "project-name"
    }
  }, [_vm._v("Project Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectSettings.name),
      expression: "projectSettings.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "project-name"
    },
    domProps: {
      "value": (_vm.projectSettings.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectSettings, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "project-customer-email"
    }
  }, [_vm._v("Project Owner")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectSettings.customerEmail),
      expression: "projectSettings.customerEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "existing-user",
      "id": "project-customer-email"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.projectSettings, "customerEmail", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select User")]), _vm._v(" "), _vm._l((_vm.projectUsers), function(projectUser) {
    return _c('option', {
      key: projectUser.email,
      attrs: {
        "disabled": projectUser.email === _vm.projectSettings.customerEmail
      },
      domProps: {
        "value": projectUser.email
      }
    }, [_vm._v(_vm._s(projectUser.email))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "dropbox-link"
    }
  }, [_vm._v("Source Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectSettings.dropboxShareLinkToFolder),
      expression: "projectSettings.dropboxShareLinkToFolder"
    }],
    staticClass: "form-control form-control--text-overflow",
    attrs: {
      "type": "text",
      "id": "dropbox-link"
    },
    domProps: {
      "value": (_vm.projectSettings.dropboxShareLinkToFolder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectSettings, "dropboxShareLinkToFolder", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center mt20"
  }, [_c('button', {
    staticClass: "btn btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.onUpdateProperties
    }
  }, [_vm._v("Submit")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2442d92c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/modals/ProjectSettingsModal.vue
// module id = 428
// module chunks = 2